const sportmodDayResultDatepicker = (wrapper: HTMLElement) => {
  if (!wrapper) return;

  const today = wrapper.getAttribute('data-today');
  const dateStart = wrapper.getAttribute('data-start');
  const dateEnd = wrapper.getAttribute('data-end');

  // Funkce pro přesměrování na nový den podle kliknutého tlačítka
  function updateSelectedDay(newSelectedDay: string) {
    const currentUrl = window.location.href;
    const newUrl = new URL(currentUrl);
    newUrl.searchParams.set('selday', newSelectedDay);
    window.location.href = newUrl.toString();
  }

  // Kliknutí na button - datum v dropdownu
  wrapper.querySelectorAll('[data-day-value]').forEach(function (button) {
    button.addEventListener('click', function () {
      const selectedDayValue = button.getAttribute('data-day-value');
      if (selectedDayValue) {
        updateSelectedDay(selectedDayValue);
      }
    });
  });

  // Funkce pro aktivaci/neaktivaci tlačítek pro předchozí a následující den
  function updateNavButtons() {
    const prevButton: HTMLButtonElement | null =
      wrapper && wrapper.querySelector('[data-id="prevDayButton"]');
    const nextButton: HTMLButtonElement | null =
      wrapper && wrapper.querySelector('[data-id="nextDayButton"]');
    const selectedDay = new URL(window.location.href).searchParams.get('selday') || today;

    if (prevButton !== null) {
      prevButton.disabled = selectedDay === dateStart;
    }

    if (nextButton !== null) {
      nextButton.disabled = selectedDay === dateEnd;
    }
  }

  // Funkce pro změnu vybraného dne o 1 den zpět nebo vpřed
  function changeSelectedDay(direction: number) {
    const selectedDay = new URL(window.location.href).searchParams.get('selday') || today;

    if (!selectedDay) {
      throw new Error('Sportmod Datepicker - Nelze určit vybraný den');
    }

    // Vytvoření nové Date objektu na základě vybraného dne
    const selectedDate = new Date(selectedDay!);

    // Přidání nebo odečítání 1 dne na základě směru
    selectedDate.setDate(selectedDate.getDate() + direction);

    const newSelectedDay = selectedDate.toISOString().split('T')[0]; // Formát Y-m-d

    updateSelectedDay(newSelectedDay); // Aktualizace URL s novým dnem
  }

  // zobrazování a skrývání rozbalovacího seznamu
  const selectedDayElement = wrapper.querySelector('[data-selected-day]');
  const datepickerList = wrapper.querySelector('[data-datepicker]');

  if (selectedDayElement && datepickerList) {
    selectedDayElement.addEventListener('click', function () {
      datepickerList.classList.toggle('day-result-datepicker__dropdown--active');
    });
  }

  // Událost pro šipku vlevo
  wrapper.querySelector('[data-id="prevDayButton"]')?.addEventListener('click', function () {
    changeSelectedDay(-1); // Odejme 1 den
  });

  // Událost pro šipku vpravo
  wrapper.querySelector('[data-id="nextDayButton"]')?.addEventListener('click', function () {
    changeSelectedDay(1); // Přidá 1 den
  });

  // Zavolání funkce pro aktualizaci tlačítek na základě aktuálně vybraného dne
  updateNavButtons();
};

export { sportmodDayResultDatepicker };
